import React, { useContext } from 'react';
// @ts-ignore
import HeatMap from 'react-heatmap-grid';
import { useLocation } from 'react-router-dom';
import usePost from '../hooks/usePost';
import Error from './error';
import Loading from './loading';
import Header from './header';
import CsvExport from './csv-export';

import DatePicker from '../components/date-picker';
import UsersSerialsContext from '../contexts/users-serials-context';

export default function PinsReport() {
  const { reportDate } = useContext(UsersSerialsContext);
  const { state } = useLocation<{ serial: string }>();
  const search = new URLSearchParams(document.location.search);
  const serial = search.get('serial');

  const pinsConf = {
    path: 'main',
    payload: {
      btn: 'pins_report',
      serial: !!serial ? serial : state.serial,
      day: reportDate,
    },
  };

  const [response, fetchPins] = usePost(pinsConf);
  const [responseCsv, fetchPinsCsv] = usePost({
    ...pinsConf,
    payload: { ...pinsConf.payload, btn: 'pins_report_csv' },
  });

  const yLabels = new Array(24).fill('00:00').map((_, i) => `${i}`);

  const xLabels = new Array(2)
    .fill(0)
    .map((_, i) => `Switch ${i + 1}`)
    .reverse();

  const data = new Array(yLabels.length)
    .fill('00:00')
    .map(() => new Array(xLabels.length).fill('0').map(() => '00:00'));

  const pins =
    !!response && response.data
      ? response.data.pins.map((pin: any) => ({
          firstPin: Number(pin['pin6']),
          secondPin: Number(pin['pin7']),
          firstPinActive: pin['pin6ActiveTime'],
          secondPinActive: pin['pin7ActiveTime'],
          currentTime: Number(pin.currentTime),
          currentDate: pin.currentDate,
        }))
      : [];

  const csvPins =
    !!responseCsv &&
    responseCsv.data &&
    responseCsv.data.pins.map((pin: any) => ({
      pin6: pin['pin6'],
      pin7: pin['pin7'],
      currentDate: pin.currentDate,
      currentTime: pin.currentTime,
      currentTemp: pin.currentTemp,
      currentPress: pin.currentPress,
      currentHumd: pin.currentHumd,
    }));

  function showPinsStatus() {
    return new Array(yLabels.length)
      .fill('00:00')
      .map((y: number, yIndex: number) => {
        return new Array(xLabels.length).fill('00:00').map((x, xIndex: number) => {
          const pin = pins.find(
            (pin: any) => Number(pin.currentTime) === yIndex
          );

          return !!pin
            ? xIndex === 0
              ? `${pin.firstPin > 0 ? pin.firstPinActive.slice(3) : '00:00'}`
              : `${pin.secondPin > 0 ? pin.secondPinActive.slice(3)  : '00:00'}`
            : '00:00';
        });
      });
  }

  return (
    <>
      <Header
        links={[
          { to: '/users-serials', name: 'Products' },
          { to: '/register', name: 'Register' },
          { to: '/logout', name: 'Logout' },
        ]}
      />
      <DatePicker />
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <button onClick={fetchPins}>Show</button>
        <button
          onClick={fetchPinsCsv}
          style={{
            background: 'none',
            border: 'none',
            padding: 0,
            textDecoration: 'underline',
            cursor: 'pointer',
          }}
        >
          Download Csv
        </button>
        {!!responseCsv && responseCsv.data && (
          <CsvExport filename='Pins' data={csvPins} date={reportDate} />
        )}
        <Error error={response.error} />
        <Loading loading={response.isLoading} />
        <HeatMap
          xLabels={xLabels}
          yLabels={yLabels}
          xLabelsLocation={'bottom'}
          xLabelsVisibility={[false, false]}
          data={!!response.data ? showPinsStatus() : data}
          xLabelWidth={100}
          squares
          cellStyle={(
            background: any,
            value: string,
            min: number,
            max: number,
            data: any,
            x: any,
            y: any
          ) => ({
            background: `rgba(66, 86, 244, ${value !== '00:00' ? Math.random() : 0})`,
            fontSize: '11px',
          })}
          cellRender={(value: string) => value && `${value}`}
          title={(value: string, unit: number) => `${value}`}
        />
        <label style={{ marginTop: '-40px', marginLeft: '60px' }}>
          Switch 1 Switch 2
        </label>
      </div>
    </>
  );
}
